// 任务路由
import Layout from '@/view/layout' // 主框架

export default {
  path: '/task',
  component: Layout,
  children: [
    {
      path: 'shoppingGuideTask',
      component: () => import('@/view/task/shoppingGuideTask'),
      name: '任务管理'
    },
    {
      path: 'shoppingGuideTask/:task_id',
      component: () => import('@/view/task/shoppingGuideTask_editor'),
      name: '任务管理编辑页面'
    }
  ]
}
